import { webKnots } from 'src/features/brands/atoms/canvas/common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'
import { generateLiningsGradient } from 'src/util/canvas'

export const w38Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  const coordinates = { x0: 150, y0: 300, x1: 700, y1: 400 }
  const gradient = generateLiningsGradient(ctx, webColor, coordinates)

  // web上のデザイン_ 左
  ctx.beginPath()
  // ctx.fillStyle = '#383838'
  ctx.fillStyle = gradient
  ctx.moveTo(580, 102) // 左上
  ctx.quadraticCurveTo(553, 140, 545, 168) // 下_外
  ctx.quadraticCurveTo(639, 158, 639, 158) // 右上_右
  ctx.quadraticCurveTo(633, 148, 620, 136) // 右上_左
  ctx.quadraticCurveTo(589, 139, 589, 139) // 下_内
  ctx.quadraticCurveTo(603, 118, 603, 118)
  ctx.quadraticCurveTo(580, 102, 580, 102)
  // ctx.quadraticCurveTo()
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // web上のデザイン_ 中央
  ctx.beginPath()
  ctx.moveTo(654, 182) // 左上
  ctx.quadraticCurveTo(505, 233, 505, 233) // 左下
  ctx.quadraticCurveTo(653, 309, 653, 309) // 右上_下
  ctx.quadraticCurveTo(672, 295, 672, 295) // 右上_上
  ctx.quadraticCurveTo(566, 229, 566, 229) // 左上_内
  ctx.quadraticCurveTo(665, 201, 665, 201)
  ctx.quadraticCurveTo(654, 182, 654, 182)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // web上のデザイン_ 右
  ctx.beginPath()
  ctx.moveTo(635, 324) // 右上
  ctx.quadraticCurveTo(528, 287, 528, 287) // 左下
  ctx.quadraticCurveTo(596, 351, 596, 351) // 右下_下
  ctx.quadraticCurveTo(609, 342, 609, 342) // 右下_上
  ctx.quadraticCurveTo(586, 322, 586, 322)
  ctx.quadraticCurveTo(620, 334, 620, 334)
  ctx.quadraticCurveTo(635, 324, 635, 324)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //

  // 外側
  ctx.moveTo(554, 89) // 左上
  ctx.quadraticCurveTo(512, 168, 490, 252) // 左下
  ctx.quadraticCurveTo(508, 310, 584, 356) // 右下
  ctx.quadraticCurveTo(587, 347, 587, 347)
  ctx.quadraticCurveTo(540, 308, 522, 281)
  ctx.quadraticCurveTo(631, 320, 631, 320)
  ctx.quadraticCurveTo(645, 308, 645, 308)
  ctx.quadraticCurveTo(496, 232, 496, 232) // 左下
  ctx.quadraticCurveTo(648, 180, 648, 180)
  ctx.quadraticCurveTo(636, 163, 636, 163)
  ctx.quadraticCurveTo(539, 174, 539, 174)
  ctx.quadraticCurveTo(549, 139, 575, 103)
  ctx.quadraticCurveTo(554, 89, 554, 89)

  // デザイン左_内側
  ctx.moveTo(603, 123) // 左上
  ctx.quadraticCurveTo(594, 136, 594, 136)
  ctx.quadraticCurveTo(615, 135, 615, 135)
  ctx.quadraticCurveTo(603, 123, 603, 123)

  // デザイン中央_内側
  ctx.moveTo(663, 207) // 右上
  ctx.quadraticCurveTo(575, 230, 575, 230)
  ctx.quadraticCurveTo(670, 289, 670, 289)
  ctx.quadraticCurveTo(686, 277, 686, 277)
  ctx.quadraticCurveTo(678, 238, 663, 207)

  // デザイン右_内側
  ctx.moveTo(599, 330) // 左上
  ctx.quadraticCurveTo(608, 338, 608, 338)
  ctx.quadraticCurveTo(609, 334, 609, 334)
  ctx.quadraticCurveTo(599, 330, 599, 330)

  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  ctx.lineWidth = 0.8
}
